import React, { useEffect, useState } from 'react';
import './Main.css';
import Header from '../Header/Header';
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash';
import DashboardKPI from '../../Components/Admin/DashboardKPI/DashboardKPI';
import PedidosRecientes from '../../Components/Admin/PedidosRecientes/PedidosRecientes';
import NewGastoModal from '../../Components/Admin/GastosData/NewGastoModal';
import NewCategoriaGastoModal from '../../Components/Admin/GastosData/NewCategoriaGastoModal';
import { useNavigate, useOutletContext } from 'react-router-dom';

export default function Main() {
    const navigate = useNavigate();
    const context = useOutletContext();
    const rol = context?.usuario?.rol?.toLowerCase();

    const [modalGastoOpen, setModalGastoOpen] = useState(false);
    const [modalCatOpen, setModalCatOpen] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);

    useEffect(() => {
        if (rol === 'cocinero') {
            navigate('/dashboard/kds', { replace: true });
        } else if (rol === 'cajero') {
            navigate('/dashboard/pos', { replace: true });
        } else if (rol === 'mesero') {
            navigate('/dashboard/meseros', { replace: true });
        }
    }, [rol, navigate]);

    const handleGastoCreado = () => {
        setRefreshKey(prev => prev + 1);
    };

    return (
        <div className="containerGrid">
            <Header />
            <section className="containerSection">
                <HeaderDash />
                <div className="containerMain">
                    {/* Indicadores KPI Financieros y Operativos */}
                    <DashboardKPI
                        key={refreshKey}
                        onAbrirModalGasto={() => setModalGastoOpen(true)}
                    />

                    {/* Pedidos Recientes */}
                    <PedidosRecientes key={`recientes-${refreshKey}`} />
                </div>
            </section>

            {/* Modal para Registrar Gasto Rápido */}
            <NewGastoModal
                isOpen={modalGastoOpen}
                onClose={() => setModalGastoOpen(false)}
                onGastoCreado={handleGastoCreado}
                onAbrirNuevaCategoria={() => setModalCatOpen(true)}
            />

            {/* Modal para Crear Categoría de Gasto */}
            <NewCategoriaGastoModal
                isOpen={modalCatOpen}
                onClose={() => setModalCatOpen(false)}
                onCategoriaCreada={() => setRefreshKey(prev => prev + 1)}
            />
        </div>
    );
}
